export const shopAsset=(path:string)=>import.meta.env.BASE_URL+path.replace(/^\//,'');
export const embeddedShop=location.pathname.startsWith('/shop-ui/');
